import { GameSession } from "../../../GameSession";
import { LogGroup } from "../../.././MyHelpers";
import { BigSymbolFreegamesState } from "./BigSymbolFreegamesState"

export class BigSymbolFreegamesSession extends GameSession
{
	protected logGroup: LogGroup;

	public state: BigSymbolFreegamesState = BigSymbolFreegamesState.Idle;

	public TotalWin: number = 0;
    public RunsStarted: number = 0;
	public RunsPlayed: number = 0;
    public RunsRemaining: number = 0;
	public HoldReels: number[] = [];

	constructor(name: string) {
		super();

		this.logGroup = new LogGroup(["Session", "BigSymbolFreegames", name]);
	}

	public Reset(): void
	{
		this.TotalWin = 0;
		this.RunsStarted = 0;
		this.RunsPlayed = 0;
        this.RunsRemaining = 0;
		this.HoldReels = [];
	}

	public Update(newSession: BigSymbolFreegamesSession)
	{
		this.TotalWin = newSession.TotalWin;
		this.RunsStarted = newSession.RunsStarted;
		this.RunsPlayed = newSession.RunsPlayed;
		this.RunsRemaining = newSession.RunsRemaining;
		this.HoldReels = newSession.HoldReels;
	}
}